/** @format */

function mediaCount(name = null) {
  return this.getMedia(name)?.length > 0 || 0;
}

export { mediaCount };
